export default __webpack_public_path__ + "static/media/arrow_right.d0157b14.svg";